export default {
  translate (dictionary, locale, key, params) {
    let str = dictionary[locale][key]

    // params - массив значений, которые нужно заменить в строке
    if (Array.isArray(params) && params.length) {
      str = str.replace(/\{(\d+)\}/g, (match, value) => {
        return params[value] || match
      })
    }

    return str
  }
}
